import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Snippet from '../Snippet';
import DocketEntry from '../../../case/docket/docketEntries/DocketEntry';
import * as docketActions from '../../../../redux/actions/docketActions';
import '../../../case/docket/Docket.less';

const CaseActivityDocketsRow = ({ row, id, getDocuments, selectedDocket }) => {
  const onGetDocuments = (docket, court_code, case_number) => {
    getDocuments({
      docket_no: docket.docket_no,
      docket_seq: docket.docket_seq,
      court_code,
      case_number,
    });
  };

  return (
    <Fragment>
      <tbody>
        <DocketEntry
          id={`docket-entry-${id}`}
          key={`docket-entry-${id}`}
          docket={row}
          redact={{}}
          showRedactPopup={null}
          case_uuid=""
          court_code={row.case_court}
          case_number={row.case_no}
          onGetDocuments={onGetDocuments}
          selectedDocket={selectedDocket}
        />
      </tbody>
      {row.parts && Object.values(row.parts).map((part, idx) => <Snippet key={idx} part={part} />)}
    </Fragment>
  );
};

CaseActivityDocketsRow.propTypes = {
  row: PropTypes.any.isRequired,
  id: PropTypes.any.isRequired,
  selectedDocket: PropTypes.any.isRequired,
  getDocuments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS(),
});

const mapDispatchToProps = {
  getDocuments: docketActions.getDocuments,
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseActivityDocketsRow);



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/CaseActivityDocketsRow.jsx